// eslint-disable-next-line import/prefer-default-export
export enum GlossaryPayload {
  ANCESTRIES = 'ancestries',
  CANCERS = 'cancers',
  CIDRS = 'cidrs',
  COUNTRIES = 'countries',
  DENSITIES = 'densities',
  FACILITY_TYPES = 'facility-types',
  FHQS = 'fhqs',
  FIELD_BANKS = 'field-banks',
  GENE_CLASSIFICATIONS = 'gene-classifications',
  GENES = 'genes',
  HRT_TYPES = 'hrt-types',
  IP_WHITELIST_MODES = 'ip-whitelist-modes',
  JOB_TITLES = 'job-titles',
  LABS = 'labs',
  LANGUAGES = 'languages',
  MENOPAUSE_STATUSES = 'menopause-statuses',
  NOTIFICATION_RULES = 'notification-rules',
  POLYP_TYPES = 'polyp-types',
  PREFIXES = 'prefixes',
  RELATIONS = 'relations',
  SKIN_FINDINGS = 'skin-findings',
  SUFFIXES = 'suffixes',
  TIMEZONES = 'timezones',
  TUMOR_TYPES = 'tumor-types',
}
